import { render, staticRenderFns } from "./ListContainer.vue?vue&type=template&id=c37f1d0c&scoped=true&"
var script = {}
import style0 from "./ListContainer.vue?vue&type=style&index=0&id=c37f1d0c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37f1d0c",
  null
  
)

export default component.exports